module.exports = __webpack_public_path__ + "static/img/sn-1.b00427b.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/snapchat/sn-1.png
// module id = 8cfA
// module chunks = 46